module.exports = __webpack_public_path__ + "static/media/rs-twitter_tbd.d3920818.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/rs-twitter_tbd.png
// module id = 61
// module chunks = 0